// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m9lN","col":"styles_col__1l_SU"};